import React from 'react';
import { LegalTabNavigation } from '../../../../components/LegalTabNavigation';

import styles from '../../styles.sass';

export function CCPA({ pathname }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.h1}>Additional California Privacy Disclosures</h1>
        <LegalTabNavigation pathname={pathname} />
        <p>
          <strong>Annex 1 – Additional California Privacy Disclosures</strong>
        </p>
        <p>Last updated, March 1 2022</p>
        <p>
          The California Consumer Privacy Act (&quot;CCPA&quot;) gives
          California residents certain rights with respect to the processing of
          personal data (known as &quot;personal information&quot; under the
          CCPA).
        </p>
        <p>
          This supplement provides additional privacy disclosures and details
          additional rights and should be read in conjunction with the Anchor{' '}
          <a href="/privacy">Privacy Policy</a>.
        </p>

        <h3>Personal Information Collected and Processed</h3>
        <p>
          Section 3 of the Anchor <a href="/privacy">Privacy Policy</a> sets
          forth the categories of personal information that we collect and
          process about you, a description of each category, and the sources
          from which we obtain each category.
        </p>
        <h3>Requests to Exercise Your Rights</h3>
        <p>
          RIGHT TO KNOW REQUEST - Under the CCPA, you have a right to request
          information about our collection, use, and disclosure of your personal
          information over the prior 12 months, and ask that we provide you with
          the following information:
        </p>
        <ol>
          <li>
            Categories of and specific pieces of personal information we have
            collected about you.
          </li>
          <li>
            Categories of sources from which we collect personal information.
          </li>
          <li>Purposes for collecting personal information.</li>
          <li>
            Categories of third parties with which we share personal
            information.
          </li>
          <li>
            Categories of personal information disclosed about you for a
            business purpose
          </li>
          <li>
            If applicable, categories of personal information sold about you and
            the categories of third parties to which the personal information
            was sold, by category or categories of personal information for each
            third party to which the personal information was sold.
          </li>
        </ol>

        <p>
          To make a verifiable request for information about the personal
          information we have collected about you, please email us at{' '}
          <a href="mailto:privacy@anchor.fm">privacy@anchor.fm</a>.
        </p>
        <p>
          RIGHT TO DELETE REQUEST - You also have a right to request that we
          delete personal information, subject to certain exceptions. You may
          exercise your right to delete by emailing us at{' '}
          <a href="mailto:privacy@anchor.fm">privacy@anchor.fm</a>.
        </p>
        <p>
          HOUSEHOLD REQUESTS - We currently do not collect household data. If
          all the members of a household make a Right to Know or Right to Delete
          request, we will respond as if the requests are individual requests.
        </p>
        <p>
          REQUESTS, GENERALLY - Please note, if you do not have a Anchor account
          we will not have enough information about you to verify your Right to
          Know and Right to Delete requests, as we do not keep sufficient
          information necessary to reidentify and link you to a prior visit to
          Anchor where data may have been collected. As such, we will be unable
          to verify and honor your requests. You may make a verifiable consumer
          request related to your personal information twice per 12-month
          period. We will not discriminate against you for exercising any of
          your rights under the CCPA.
        </p>
        <p>
          REQUESTS MADE THROUGH AGENTS - You may designate, in writing or
          through a power of attorney, an authorized agent to make requests on
          your behalf to exercise your rights. Before accepting such a request
          from an agent, we will require the agent to provide proof you have
          authorized it to act on your behalf, and we may need you to verify
          your identity directly with us.
        </p>
        <p>
          Between January 1 and December 31, 2021 we received 4 global
          verifiable right to delete requests and 0 right to know requests. We
          complied 4 right to deletion requests and denied 0. The average
          response rate for the right to delete was 16 days.
        </p>
        <h3>Disclosures of Personal Information for a Business Purpose</h3>
        <p>
          In the preceding 12 months, we have disclosed certain data from the
          following categories of personal information to the categories of
          recipients listed in Section 5 of the Anchor{' '}
          <a href="/privacy">Privacy Policy</a> for one or more business
          purposes:
        </p>
        <ul>
          <li>User Data</li>
          <li>Usage Data</li>
          <li>Payment and Purchase Data</li>
          <li>Contest, Surveys and Sweepstakes Data</li>
        </ul>
        <h3>Sale of Personal Information</h3>
        <p>
          We do not sell personal information. We have taken substantial steps
          to identify and remediate any data sharing arrangements that could
          constitute a &quot;sale&quot; under the CCPA.
        </p>
        <h3>Contact Us</h3>
        <p>
          You may contact us by using the{' '}
          <a href="https://help.anchor.fm/hc/en-us/requests/new">
            contact form
          </a>
          , or emailing us at{' '}
          <a href="mailto:privacy@anchor.fm">privacy@anchor.fm</a>.
        </p>
      </div>
    </div>
  );
}
